import Loading from "@/components/ui/loading";

export const LoadingOrganizations = () => {
  return (
    <div
      data-testid="loadingOrganizationsCard"
      className="flex justify-center items-center w-full"
    >
      <Loading size="md" />
    </div>
  );
};
